import { useFeatureWithToggle } from "../../../common/FeatureFlags.js";

export const useApplyOverrides = () => {
  const { enabled, set } = useFeatureWithToggle("ApplyOverrides");
  return [enabled, set] as [boolean, (newValue: boolean) => void];
};
